export const ScrollOptions = {
  duration: 350,
  smooth: true,
  offset: -70,
};
